{
  "scale": 0.4,
  "workLights": {
    "color": "#ffb030",
    "sizeM": 24,
    "blinkPeriodS": 1.6,
    "onFraction": 0.55
  }
}
